// Event data for the BMW Art Car Tour
const events = [
    {
      id: 1,
      location: "Vienna, Austria",
      venue: "SPARK Art Fair and MAK Museum",
      startDate: new Date("2025-03-20"),
      endDate: new Date("2025-03-21"),
      cars: ["#3 Roy Lichtenstein", "#4 Andy Warhol", "#6 Robert Rauschenberg", "#14 David Hockney", "#16 Jeff Koons"],
      coordinates: [16.3738, 48.2082],
      active: false
    },
    {
      id: 2,
      location: "Hong Kong",
      venue: "Art Basel Hong Kong",
      startDate: new Date("2025-03-28"),
      endDate: new Date("2025-03-30"),
      cars: ["#20 Julie Mehretu"],
      coordinates: [114.1694, 22.3193],
      active: false
    },
    {
      id: 3,
      location: "Shanghai, China",
      venue: "Shanghai Auto Show",
      startDate: new Date("2025-04-23"),
      endDate: new Date("2025-05-05"),
      cars: ["#20 Julie Mehretu"],
      coordinates: [121.4737, 31.2304],
      active: false
    },
    {
      id: 4,
      location: "Dubai, United Arab Emirates",
      venue: "Art Dubai",
      startDate: new Date("2025-04-18"),
      endDate: new Date("2025-04-20"),
      cars: ["# TBA"],
      coordinates: [55.2708, 25.2048],
      active: false
    },
    {
      id: 5,
      location: "Zurich, Switzerland",
      venue: "50 Years of BMW Schweiz",
      startDate: new Date("2025-05-01"),
      endDate: new Date("2025-05-31"),
      cars: ["#5 Ernst Fuchs", "#8 Ken Done", "#11 A.R. Penck", "#14 David Hockney", "#15 Jenny Holzer"],
      coordinates: [8.5417, 47.3769],
      active: false
    },
    {
      id: 6,
      location: "Taipei, Taiwan",
      venue: "Taipei Dangdai",
      startDate: new Date("2025-05-09"),
      endDate: new Date("2025-05-11"),
      cars: ["# TBA"],
      coordinates: [121.5654, 25.0330],
      active: false
    },
    {
      id: 7,
      location: "Bratislava, Slovakia",
      venue: "",
      startDate: new Date("2025-05-14"),
      endDate: new Date("2025-06-01"),
      cars: ["#2 Frank Stella", "#7 Michael Jagamara Nelson", "#9 Matazo Kayama"],
      coordinates: [17.1077, 48.1486],
      active: false
    },
    {
      id: 8,
      location: "Stockholm, Sweden",
      venue: "Market Art Fair",
      startDate: new Date("2025-05-15"),
      endDate: new Date("2025-05-18"),
      cars: ["#1 Alexander Calder", "#3 Roy Lichtenstein", "#4 Andy Warhol", "#17 Jeff Koons"],
      coordinates: [18.0686, 59.3293],
      active: false
    },
    {
      id: 9,
      location: "Lake Como, Italy",
      venue: "Concorso d'Eleganza Villa d'Este",
      startDate: new Date("2025-05-23"),
      endDate: new Date("2025-05-25"),
      cars: ["#13 Sandro Chia"],
      coordinates: [9.2644, 45.8083],
      active: false
    },
    {
      id: 10,
      location: "Munich, Germany",
      venue: "BMW Museum",
      startDate: new Date("2025-06-16"),
      endDate: new Date("2026-01-01"),
      cars: ["#7 Michael Jagamara Nelson", "#8 Ken Done", "#13 Sandro Chia"],
      coordinates: [11.5820, 48.1351],
      active: false
    },
    {
      id: 11,
      location: "Munich, Germany",
      venue: "BMW Welt",
      startDate: new Date("2025-06-16"),
      endDate: new Date("2025-08-31"),
      cars: ["#15 Jenny Holzer", "#20 Julie Mehretu"],
      coordinates: [11.5564, 48.1772],
      active: false
    },
    {
      id: 12,
      location: "Båstad, Sweden",
      venue: "The Aurora",
      startDate: new Date("2025-06-27"),
      endDate: new Date("2025-06-29"),
      cars: ["#1 Alexander Calder", "#3 Roy Lichtenstein", "#4 Andy Warhol", "#17 Jeff Koons"],
      coordinates: [12.8466, 56.4269],
      active: false
    },
    {
      id: 13,
      location: "Den Haag, The Netherlands",
      venue: "Louwman Museum",
      startDate: new Date("2025-07-03"),
      endDate: new Date("2025-08-31"),
      cars: ["#1 Alexander Calder", "#2 Frank Stella", "#3 Roy Lichtenstein", "#4 Andy Warhol", "#10 César Manrique", "#12 Esther Mahlangu", "#14 David Hockney", "#17 Jeff Koons"],
      coordinates: [4.3007, 52.0705],
      active: false
    },
    {
      id: 14,
      location: "Istanbul, Turkey",
      venue: "Contemporary Istanbul",
      startDate: new Date("2025-09-24"),
      endDate: new Date("2025-09-28"),
      cars: ["#1 Alexander Calder", "#20 Julie Mehretu"],
      coordinates: [28.9784, 41.0082],
      active: false
    }
  ];
  
  // Export the events array directly, not as a default export
  export { events };